@if (isTeacher) {
  <div
    class="algolia-filters-container"
    [ngClass]="getCssClass()"
    >
    <section-label
      class="section-label"
      [sectionLabelContent]="filterSectionLabel"
      [isTeacher]="isTeacher"
    ></section-label>
    @if (!filters.length) {
      <section>
        <mat-spinner [diameter]="40"></mat-spinner>
      </section>
    }
    @if (filters.length) {
      <section class="algolia-filters-buckets">
        @for (filter of filters; track filter) {
          <div class="algolia-filter-bucket">
            <mat-form-field appearance="outline">
              <mat-label>{{ filter.label }}</mat-label>
              <mat-select
                [multiple]="filter.attribute !== 'visibility'"
                [value]="getSelected(filter.attribute)"
                    (selectionChange)="
                        updateFilterValues(filter.attribute, $event.value)
                    "
                (openedChange)="emitFilterValues($event)"
                >
                @for (val of filter.values; track val) {
                  <mat-option
                    [value]="getValue(filter.attribute, val)"
                    >
                    @if (filter.attribute === 'assetTypeId') {
                      <img
                        class="assignment-pill-icon mat-icon"
                        [src]="getIconPath(val)"
                        />
                    }
                    {{ getDisplayName(filter.attribute, val) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </section>
    }
    <section class="filter-summary" [ngClass]="{ white: !isTeacher }">
      <div>
        @if (resourcesTabActive && !resourceCategoriesCount) {
          <span
            class="total"
            >{{ params?.total + globalResourcesCount }}</span
            >
          }
          @if (
            resourcesTabActive &&
            resourceCategoriesCount &&
            mathResourcesListView
            ) {
            <span
              class="total"
              >{{ params?.total }}</span
              >
            }
            @if (
              resourcesTabActive &&
              resourceCategoriesCount &&
              !mathResourcesListView
              ) {
              <span
                class="total"
                >{{ resourceCategoriesCount + globalResourcesCount }}</span
                >
              }
              @if (assignablesTabActive) {
                <span class="total">{{
                  params?.total
                }}</span>
              }
              <span>{{ resourcesTabActive ? " Resource" : " Assignment" }}</span>
              @if (params?.total > 1) {
                <span>s</span>
              }
              <span> Found</span>
            </div>
            <span (click)="onReset()" class="reset">Reset All Filters</span>
          </section>
        </div>
      }

      <!-- Student Filters -->
      @if (isStudent && filters.length) {
        <div
          class="algolia-filters-container-student"
          [ngClass]="getCssClass()"
          >
          <div class="filters-label-container">
            <span class="data-label font-size-12px">Filter By</span>
          </div>
          <section class="filters-container">
            @if (filters.length) {
              <section class="algolia-filters-buckets">
                @for (filter of filters; track filter) {
                  <div class="algolia-filter-bucket">
                    <mat-form-field>
                      <mat-label>{{ filter.label }}</mat-label>
                      <mat-select
                        [multiple]="filter.attribute !== 'visibility'"
                        [value]="getSelected(filter.attribute)"
                        (selectionChange)="
                            updateFilterValues(filter.attribute, $event.value)
                        "
                        (openedChange)="emitFilterValues($event)"
                        >
                        @for (val of filter.values; track val) {
                          <mat-option
                            [value]="getValue(filter.attribute, val)"
                            >
                            @if (filter.attribute === 'assetTypeId') {
                              <img
                                class="assignment-pill-icon mat-icon"
                                [src]="getIconPath(val)"
                                />
                            }
                            {{ getDisplayName(filter.attribute, val) }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              </section>
            }
            <section class="filter-summary" [ngClass]="{ white: !isTeacher }">
              <div>
                @if (!resourceCategoriesCount) {
                  <span class="total">{{
                    params?.total + globalResourcesCount
                  }}</span>
                }
                @if (resourceCategoriesCount && mathResourcesListView) {
                  <span
                    class="total"
                    >{{ params?.total }}</span
                    >
                  }
                  @if (resourceCategoriesCount && !mathResourcesListView) {
                    <span
                      class="total"
                      >{{ resourceCategoriesCount + globalResourcesCount }}</span
                      >
                    }
                    <span>{{
                      resourcesTabActive ? " Result" : " Assignment"
                    }}</span>
                    @if (params?.total > 1) {
                      <span>s</span>
                    }
                    <span> Found</span>
                  </div>
                  <span (click)="onReset()" class="reset">Reset All Filters</span>
                </section>
              </section>
            </div>
          }
          @if (isStudent && !filters.length) {
            <section>
              <mat-spinner [diameter]="40"></mat-spinner>
            </section>
          }
